import { createFileRoute } from '@tanstack/react-router';
import FileNumbers from '../../../features/baseData/fileNumbers/fileNumbers';
import {
  createPermissionGuard,
  FILE_NUMBERS_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/aktenzeichen/')({
  component: FileNumbers,
  beforeLoad: createPermissionGuard(
    getPermissionSet(FILE_NUMBERS_PERMISSIONS, 'READ'),
  ),
});

export const ListFileNumberRoute = Route;
